var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main",attrs:{"id":"app"}},[_c('div',{staticClass:"content"},[_c('router-view')],1),_c('div',{staticClass:"weChat-wrapper"},[_c('we-chat')],1),_c('new-user-tutorials-comp'),_c('div',{staticClass:"bottom-footer"},[(!_vm.$route.meta.hideFooter)?_c('singleron-footer-comp'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }